import React, { useContext } from "react";
import { getAuth, signOut } from "firebase/auth";
import { Link } from 'react-router-dom';
import { FirebaseContext } from "../../FirebaseContext";
import './TopBar.css'; // Import the CSS file for styling
import logoutIcon from './logout-symbol.svg'; // Import the SVG

const handleLogout = () => {
    const auth = getAuth();
    signOut(auth)
        .then(() => {
            console.log("User signed out.");
        })
        .catch((error) => {
            console.error("Error signing out: ", error);
        });
};

export const TopBar = () => {
    const { userData } = useContext(FirebaseContext);

    return (
        <div className="topBar">
            <div className="topBar-left">
                <div className="loading-text">
                    Creating character
                </div>
            </div>
            {/* <div className="topBar-center">
                
                <Link to="/home" className="topBar-link">Home</Link>
                <Link to="/about" className="topBar-link">About</Link>
                <Link to="/contact" className="topBar-link">Contact</Link>
            </div> */}
            <div className="topBar-right">
                {/* <span className="userName">{userData.displayName}</span> */}
                <img 
                    src={logoutIcon} 
                    alt="Logout" 
                    className="logoutIcon" 
                    title="Sign Out"
                    onClick={handleLogout}
                />
            </div>
        </div>
    );
};
